/**
 * 设备识别（浏览器端）
 *
 * ⚠️ 这个正则必须与 nginx 里的 `map $http_user_agent $ytx_is_mobile` 完全一致，
 *    见 deploy/nginx-yuetaixing.conf 的 ★3 段。
 *
 *    两边不一致的后果：服务端不跳、浏览器端跳（或反之），
 *    同一个访客会看到两套判断结果，百度也会认为「跳转规则不稳定」。
 *    改这里时，nginx map 的第 39 行要一起改。
 *
 * 之所以两边都要有：
 *   - nginx（首选）→ 服务器端 302，百度蜘蛛和首屏都受益；
 *   - 浏览器端（兜底）→ 宝塔改「网站设置/域名管理」时会按自己的模板重写站点配置，
 *     万一 map 块被冲掉，手机访客至少不会看到 PC 版。
 */
const MOBILE_UA_RE = /(Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini|Mobile|Windows Phone|HarmonyOS)/i

export function isMobileUA () {
  if (typeof navigator === 'undefined') return false
  return MOBILE_UA_RE.test(navigator.userAgent)
}

export default isMobileUA
